import { NavItem } from './nav-item/nav-item';

// Sidebar for non-admin users:
// - No "Add/Create" actions
// - No main settings section/routes
export const nonAdminItems: NavItem[] = [
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboard',
  },
  {
    displayName: 'Trips',
    iconName: 'route',
    route: 'apps/trips',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/trips/list',
      },
    ],
  },
  {
    displayName: 'Fuel Orders',
    iconName: 'gas-station',
    route: 'apps/fuel-orders',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/fuel-orders/list',
      },
    ],
  },
  {
    displayName: 'Stations',
    iconName: 'building-warehouse',
    route: 'apps/stations',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/stations/list',
      },
    ],
  },
  {
    displayName: 'Parking',
    iconName: 'parking',
    route: 'apps/parking',
    children: [
      {
        displayName: 'Config',
        iconName: 'point',
        route: 'apps/parking/config',
      },
      {
        displayName: 'Yards',
        iconName: 'point',
        route: 'apps/parking/yards',
      },
      {
        displayName: 'Owners',
        iconName: 'point',
        route: 'apps/parking/owners',
      },
      {
        displayName: 'Sessions',
        iconName: 'point',
        route: 'apps/parking/sessions',
      },
      {
        displayName: 'Bills',
        iconName: 'point',
        route: 'apps/parking/bills',
      },
    ],
  },
  {
    displayName: 'Vehicles',
    iconName: 'truck',
    route: 'apps/vehicles',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/vehicles/list',
      },
    ],
  },
  {
    displayName: 'Trailers',
    iconName: 'truck-loading',
    route: 'apps/trailers',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/trailers/list',
      },
    ],
  },
  {
    displayName: 'Drivers',
    iconName: 'user',
    route: 'apps/drivers',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/drivers/list',
      },
    ],
  },
  {
    displayName: 'Inventory',
    iconName: 'packages',
    route: 'apps/inventory',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/inventory/list',
      },
      {
        displayName: 'Tyres',
        iconName: 'point',
        route: 'apps/inventory/tyres',
      },
    ],
  },
  {
    displayName: 'Payroll',
    iconName: 'cash',
    route: 'apps/payroll',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/payroll/list',
      },
      {
        displayName: 'Statutory rates',
        iconName: 'point',
        route: 'apps/payroll/statutory',
      },
      {
        displayName: 'Deduction types',
        iconName: 'point',
        route: 'apps/payroll/deduction-types',
      },
      {
        displayName: 'Staff loans',
        iconName: 'point',
        route: 'apps/loans/list',
      },
      {
        displayName: 'Reports',
        iconName: 'point',
        route: 'apps/payroll/reports',
      },
      {
        displayName: 'Department payroll',
        iconName: 'point',
        route: 'apps/payroll/reports/department-analysis',
      },
      {
        displayName: 'SHIF deductions',
        iconName: 'point',
        route: 'apps/payroll/reports/shif',
      },
      {
        displayName: 'PAYE',
        iconName: 'point',
        route: 'apps/payroll/reports/paye',
      },
      {
        displayName: 'NSSF',
        iconName: 'point',
        route: 'apps/payroll/reports/nssf',
      },
      {
        displayName: 'Affordable housing',
        iconName: 'point',
        route: 'apps/payroll/reports/housing-levy',
      },
    ],
  },
  {
    displayName: 'Advances',
    iconName: 'wallet',
    route: 'apps/advances',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/advances/list',
      },
    ],
  },
  {
    displayName: 'Finance',
    iconName: 'receipt',
    route: 'apps/finance',
    children: [
      {
        displayName: 'Expenses',
        iconName: 'point',
        route: 'apps/finance/expenses/list',
      },
      {
        displayName: 'Expense categories',
        iconName: 'point',
        route: 'apps/finance/expenses/categories',
      },
      {
        displayName: 'Petty Cash Funds',
        iconName: 'point',
        route: 'apps/finance/petty-cash/list',
      },
    ],
  },
  {
    displayName: 'Payments',
    iconName: 'moneybag',
    route: 'apps/payments',
    children: [
      {
        displayName: 'Payment List',
        iconName: 'point',
        route: 'apps/payments/payments',
      },
      {
        displayName: 'Payment Methods',
        iconName: 'point',
        route: 'apps/payments/methods',
      },
    ],
  },
  {
    displayName: 'Reports',
    iconName: 'report-analytics',
    route: 'apps/reports',
    children: [
      {
        displayName: 'Overview',
        iconName: 'point',
        route: 'apps/reports',
      },
      {
        displayName: 'Station Payables',
        iconName: 'point',
        route: 'apps/reports/station-payables',
      },
      {
        displayName: 'Station Credit Account',
        iconName: 'point',
        route: 'apps/reports/station-credit',
      },
      {
        displayName: 'Station Orders',
        iconName: 'point',
        route: 'apps/reports/station-orders',
      },
      {
        displayName: 'Station Fuel Ledger',
        iconName: 'point',
        route: 'apps/reports/station-fuel-account',
      },
      {
        displayName: 'Fuel Orders',
        iconName: 'point',
        route: 'apps/reports/fuel-orders',
      },
      {
        displayName: 'Expenses',
        iconName: 'point',
        route: 'apps/reports/expenses',
      },
      {
        displayName: 'Vehicle Expenses',
        iconName: 'point',
        route: 'apps/reports/vehicle-expenses',
      },
      {
        displayName: 'Petty Cash',
        iconName: 'point',
        route: 'apps/reports/petty-cash',
      },
      {
        displayName: 'Workshop Stock',
        iconName: 'point',
        route: 'apps/reports/workshop-stock',
      },
      {
        displayName: 'Tyres',
        iconName: 'point',
        route: 'apps/reports/tyres',
      },
    ],
  },

  {
    navCap: 'Settings',
  },
  {
    displayName: 'Branches',
    iconName: 'building-store',
    route: 'apps/branches',
    children: [
      {
        displayName: 'List',
        iconName: 'point',
        route: 'apps/branches/list',
      },
    ],
  },
  {
    displayName: 'Company Details',
    iconName: 'building',
    route: '/apps/companies/settings',
  },
  {
    displayName: 'Account Setting',
    iconName: 'user-circle',
    route: '/apps/users/account',
  },
];
